import quickFetch from 'quick-fetch';
// @ts-expect-error apparently this doesn't have types yet
import { buildErrorResponse } from 'hub-http/adapters/adapterUtils';
// @ts-expect-error apparently this doesn't have types yet
import { responseError } from 'hub-http/helpers/response';
export default ((name, {
  removeRequestOnSuccess = true
} = {}) => {
  const earlyMetaRequest = quickFetch.getRequestStateByName(name);
  if (!earlyMetaRequest) return null;
  return new Promise((resolve, reject) => {
    earlyMetaRequest.whenFinished(result => {
      resolve(result);
      if (removeRequestOnSuccess) {
        quickFetch.removeEarlyRequest(name);
      }
    });
    earlyMetaRequest.onError((xhr, errorCode) => {
      const errorReponse = buildErrorResponse(xhr, `early request '${name}' failed`, errorCode);
      reject(responseError(errorReponse, `early request '${name}' failed`, errorCode));
      quickFetch.removeEarlyRequest(name);
    });
  });
});